import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { track } from '../modules/tracking';
import {
    FILTER,
    FILTERS,
    CLOSE_FILTERS,
    OPEN_FILTERS
} from '../modules/constants';

const COMPONENT_CLASS_NAME = 'filter';

/**
 * Show/hide filter component. Also display number of applied filters.
 *
 * @function
 * @param       {boolean} showFilter   useState boolean. Should filter be shown (true when button is clicked)
 * @param       {function} setShowFilter useState function. Used to control opening and closing of filters component.
 * @param       {number} filterCount   selected filter item count.
 * @param       {function} setShade    useState function to set the shade behind the filters on and off.
 * @constructor
 */
function FilterButton({ showFilter, setShowFilter, filterCount, setShade }) {
    let ourClassName = showFilter ? 'filterButton open' : 'filterButton';
    ourClassName += filterCount === 0 ? '' : ' count';

    useEffect(() => {
        if (
            typeof setShade !== 'function' ||
            typeof setShowFilter !== 'function'
        ) {
            return;
        }
        if (showFilter === false) {
            setShade({ closer: 'FilterButton', shade: false });
        } else if (showFilter === true) {
            setShade({
                opener: 'FilterButton',
                shade: true,
                onClick: () => {
                    setShowFilter(false);
                    setShade({ closer: 'FilterButton', shade: false });
                    track('Shade: Click: close filters')();
                },
                filters: true
            });
        }

        return () => setShade({ closer: 'FilterButton', shade: false });
    }, [showFilter]);

    return (
        <div className={ourClassName}>
            <button
                className={COMPONENT_CLASS_NAME}
                title={showFilter ? CLOSE_FILTERS : OPEN_FILTERS}
                onClick={() => {
                    setShowFilter(!showFilter);
                    track(
                        `Filters Button: Click: ${
                            showFilter ? 'close' : 'open'
                        } filters`
                    )();
                }}
            >
                {filterCount > 0 ? filterCount + ' ' : ''}
                {filterCount === 1 ? FILTER : FILTERS}
            </button>
        </div>
    );
}

FilterButton.propTypes = {
    showFilter: PropTypes.bool,
    filterCount: PropTypes.number,
    setShowFilter: PropTypes.func,
    setShade: PropTypes.func,
    shade: PropTypes.object
};

export { FilterButton };
